import { render, staticRenderFns } from "./MyPurchasedTickets.vue?vue&type=template&id=5bec9b5e"
import script from "./MyPurchasedTickets.vue?vue&type=script&lang=js"
export * from "./MyPurchasedTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports